export default __webpack_public_path__ + "static/media/statefarm-horizontal-red (1).726af428.png";